<template>
  <div>
    <el-dialog width="80%" title="Endereço" :visible.sync="dialog" append-to-body>
      <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
        <el-form-item class="is-required">
          <el-radio-group v-model="ruleForm.type">
            <el-radio :disabled="(isPrincipal && !isEditing) || editingMain" label="main">Principal</el-radio>
            <el-radio :disabled="editingMain || isBillet" label="billet">Faturamento</el-radio>
            <el-radio label="payment" :disabled="editingMain">Pagamento</el-radio>
            <el-radio label="collect" :disabled="editingMain" >Coleta</el-radio>
            <el-radio label="other"   :disabled="editingMain" >Outro</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('nome')" prop="name" class="is-required">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="14" :sm="8" :md="8" :lg="6" :xl="6">
            <el-form-item :label="$t('cep')" prop="cep" class="is-required">
              <el-input maxlength="9" v-model="ruleForm.cep" v-mask="'#####-###'" @blur="zipcode()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('endereco')" prop="address" class="is-required">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="24" :md="18" :lg="12" :xl="12">
            <el-form-item :label="$t('bairro')" prop="neighborhood" class="is-required">
              <el-input v-model="ruleForm.neighborhood"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item :label="$t('cidade')" prop="city" class="is-required">
              <el-input v-model="ruleForm.city" maxlength="80"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6" :lg="4" :xl="3">
            <el-form-item :label="$t('estado')" prop="state" class="is-required">
              <el-input v-model="ruleForm.state" maxlength="2" class="uppercase"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="4">
            <el-form-item :label="$t('numero')" prop="number" class="is-required">
              <el-input maxlength="6" v-model="ruleForm.number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="12" :xl="12">
            <el-form-item :label="$t('complemento')" prop="extent">
              <el-input v-model="ruleForm.extent" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">Cancelar</el-button>
        <el-button type="warning" @click="add"> {{ isEditing ? 'Atualizar' : 'Adicionar' }}</el-button>
      </span>
    </el-dialog>
    <el-row type="flex" justify="end">
      <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
        <el-button
          class="right"
          type="primary"
          icon="el-icon-plus"
          @click="open"
          >{{ $t("adicionar") }}</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      stripe
      ref="tableServices"
      style="width: 100%"
      :default-sort="{ prop: 'name', order: 'ascending' }"
    >
      <el-table-column
        sortable
        width="120"
        prop="type"
        :label="$t('tipo')"
      >
        <template slot-scope="scope">
          {{ 
            scope.row.type === 'main'
              ? 'Principal'
              : scope.row.type === 'billet'
                ? 'Fatura'
                : scope.row.type === 'payment'
                  ? 'Pagamento'
                  : scope.row.type === 'collect'
                    ? 'Coleta'
                    : 'Outro' 
          }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="name"
        width="200"
        :label="$t('nome')"
      ></el-table-column>
      <el-table-column
        sortable
        prop="zipcode"
        width="120"
        :label="$t('cep')"
      ></el-table-column>
      <el-table-column
        sortable
        prop="address"
        :label="`${$t('endereco')}?`"
      >
      </el-table-column>
      <el-table-column label="#" width="120">
        <template slot-scope="scope">
          <el-button
            type="info"
            icon="el-icon-edit"
            @click="edit(scope.row, scope.$index)"
            circle
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="remove(scope.row.zipcode)"
            circle
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import ZipMixins from "../../../../mixins/zipcode";

export default {
  name: "CustomerTableAddress",
  mixins: [ZipMixins],
  props: ['tableData'],
  computed: {
    isPrincipal() {
      return this.tableData && this.tableData.find(x => x.type === 'main') !== undefined;
    },
    isBillet() {
      return this.tableData && this.tableData.find(x => x.type === 'billet') !== undefined;
    }
  },
  data() {
    return {
      dialog: false,
      isEditing: false,
      editingMain: false,
      editIndex: null,
      ruleForm: {
        id: null,
        cep: '',
        address: '',
        name: '',
        city: '',
        neighborhood: '',
        state: '',
        number: '',
        extent: '',
        type: 'main',
      }
    };
  },
  methods: {
    open() {
      this.isEditing = false;
      this.editingMain = false;
      this.ruleForm = {
        id: null,
        cep: '',
        address: '',
        name: '',
        city: '',
        neighborhood: '',
        state: '',
        number: '',
        extent: '',
        type: this.isPrincipal ? 'collect' : 'main',
      };
      this.dialog = true;
    },
    edit(row, index) {
      this.isEditing = true;
      this.editingMain = row.type === 'main';
      this.editIndex = index;
      this.ruleForm = {
      name: row.name || '',
      cep: row.zipcode || '',
      address: row.address || '',
      number: row.number || '',
      neighborhood: row.neighborhood || '',
      city: row.city || '',
      state: row.state || '',
      extent: row.extent || '',
      type: row.type || 'main'
      };

      this.editingMain = this.ruleForm.type === 'main';
      this.dialog = true;
    },
    remove(index) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-endereco", { name: index }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        vm.$emit("remove", index); // <- envia o objeto correto
      });
    },
    add() {
      const vm = this;
      if (!vm.ruleForm.name) return this.$message({ type: "error", message: "Nome é obrigatório!" });
      if (!vm.ruleForm.type) return this.$message({ type: "error", message: "Tipo de endereço é obrigatório!" });
      if (!vm.ruleForm.cep) return this.$message({ type: "error", message: "CEP é obrigatório!" });
      if (!vm.ruleForm.address) return this.$message({ type: "error", message: "Endereço é obrigatório!" });
      if (!vm.ruleForm.city) return this.$message({ type: "error", message: "Cidade é obrigatória!" });
      if (!vm.ruleForm.neighborhood) return this.$message({ type: "error", message: "Bairro é obrigatório!" });
      if (!vm.ruleForm.state) return this.$message({ type: "error", message: "Estado é obrigatório!" });
      if (!vm.ruleForm.number) return this.$message({ type: "error", message: "Número é obrigatório!" });

      if (!vm.isEditing) {
        const zipcodeData = vm.tableData.find(x => x.zipcode === vm.ruleForm.cep);
        if (zipcodeData) return this.$message({ type: "error", message: "CEP já cadastrado para o cliente!" })
      }

      const payload = {
        ...vm.ruleForm,
        zipcode: vm.ruleForm.cep,
      };

      if (vm.isEditing) {
        vm.$emit("update", payload);
      } else {
        vm.$emit("add", payload);
      }
      vm.dialog = false;
      this.isEditing = false;
      this.editIndex = null;
    },
  }
};
</script>

<style>
.uppercase {
  text-transform: uppercase;
}
</style>